import HomeUser from '../icons/HomeUser';
import { ServiceCategoryItemType } from '../types';

export default {
    type: 'solutions',
    displayName: 'Expert solutions',
    IconComponent: HomeUser,
    order: 3,
} as ServiceCategoryItemType;
